import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { CLP } from "@/lib/format";
import { enqueue, isOffline } from "@/lib/attQueue";

export function PaidToggle({ x, onChange }) {
  const [busy, setBusy] = useState(false);
  if (!x.direct) return null;
  const toggle = async () => {
    setBusy(true);
    const offline = () => { enqueue({ type: "paid", reservation_id: x.reservation_id, paid: !x.direct_paid }); toast.info("Sin señal: pago guardado en este teléfono. Se enviará al volver la conexión."); onChange(); };
    if (!navigator.onLine) { offline(); setBusy(false); return; }
    try { await api.put(`/business/reservations/${x.reservation_id}/direct-paid`, { paid: !x.direct_paid }, { offlineFallback: true }); onChange(); }
    catch (e) { if (isOffline(e)) offline(); else toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={toggle} disabled={busy} data-testid={`att-paid-${x.reservation_id}`}
      className={`shrink-0 whitespace-nowrap inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold border transition-colors ${x.direct_paid ? "bg-emerald-600 border-emerald-600 text-white" : "border-amber-400 text-amber-700 bg-amber-50 hover:bg-amber-100"}`}
      title={x.direct_paid ? "Toca para marcar como pendiente de pago" : "Toca para marcar como pagado"}>
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <>{x.direct_paid ? "Pagado" : "Pendiente de pago"}{x.direct_price_clp > 0 && <span className="opacity-80">· {CLP(x.direct_price_clp)}</span>}</>}
    </button>
  );
}
